var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2TipBoxOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 140,
    fill: "none",
    viewBox: "0 0 90 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7F9",
    d: "M3.956 19.1a5 5 0 0 1 5-5h72.088a5 5 0 0 1 5 5v70.576a5 5 0 0 1-5 5H8.956a5 5 0 0 1-5-5V19.101z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E5ECF0",
    strokeWidth: 2,
    d: "M4.956 19.1a4 4 0 0 1 4-4h72.088a4 4 0 0 1 4 4v70.576a4 4 0 0 1-4 4H8.956a4 4 0 0 1-4-4V19.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E6B",
    fillRule: "evenodd",
    d: "M8.934 16.115a3 3 0 0 0-3 3v68.547a5 5 0 0 0 5 5h4.89V27.194c0-7.017 13.846-11.079 13.846-11.079H8.934z",
    clipRule: "evenodd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7F9",
    d: "M35.605 3a3 3 0 0 1 3-3h11.802a3 3 0 0 1 3 3v11.1H35.605V3z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.846,
    height: 3.022,
    x: 37.583,
    y: 4.029,
    fill: "#E5ECF0",
    rx: 1.511
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5ECF0",
    fillRule: "evenodd",
    d: "M82.066 16.115a2 2 0 0 1 2 2V88.67a5 5 0 0 1-5 5h-4.89V27.194c0-7.017-13.846-11.079-13.846-11.079h21.736z",
    clipRule: "evenodd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.912 75.307l8.499.047-.005.859-8.499-.047z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 8,
    height: 35,
    x: 21,
    y: 75,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.337 75.309l7.65.042-.477 9.451-.283-.002-.165 4.297-.493-.003-1.744 20.615-1.7-.009-1.52-20.634-.493-.002-.118-4.298-.283-.002-.374-9.455z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.337 75.309l7.65.042-.477 9.451-6.8-.038-.373-9.455z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.97 83.906l6.29.035-.198 5.156-5.95-.033-.142-5.158z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.542 88.207l5.1.028-1.817 21.474-1.7-.009-1.583-21.493zM24.125 109.7l1.7.01-.005.858-1.7-.009z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.392 88.211l.988 21.49-.255-.001-1.503-20.634-.51-.002-.147-4.298-.255-.002-.378-8.596 1.277-.422.783 12.465zM26.791 88.23l-1.221 21.478.255.001 1.727-20.615.51.003.193-4.296.255.001.471-8.591-1.272-.437-.918 12.456z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M29.406 76.213l-8.355-.046-.148.858 8.47.047.033-.859zm-7.566 8.552l7.52.042-.03.859-7.624-.042.134-.859zm.782 4.301l4.93.028-.022.859-4.998-.028.09-.859z",
    clipRule: "evenodd",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.253 75.307l8.499.047-.005.859-8.499-.047z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 9,
    height: 35,
    x: 56,
    y: 75,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M56.678 75.309l7.649.042-.476 9.451-.284-.002-.164 4.297-.493-.003-1.744 20.615-1.7-.009-1.52-20.634-.493-.002-.118-4.298-.284-.002-.373-9.455z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.678 75.309l7.649.042-.476 9.451-6.8-.038-.373-9.455z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.311 83.906l6.29.035-.198 5.156-5.95-.033-.142-5.158z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.883 88.207l5.1.028-1.817 21.474-1.7-.009-1.583-21.493zM59.466 109.7l1.7.01-.005.858-1.7-.009z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.733 88.211l.988 21.49-.255-.001-1.503-20.634-.51-.002-.147-4.298-.255-.002-.378-8.596 1.277-.422.782 12.465zM62.132 88.23l-1.221 21.478.255.001 1.726-20.615.51.003.194-4.296.255.001.471-8.591-1.272-.437-.918 12.456z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M64.747 76.213l-8.355-.046-.149.858 8.47.047.034-.859zm-7.566 8.552l7.52.042-.031.859-7.623-.042.134-.859zm.782 4.301l4.93.028-.022.859-4.998-.028.09-.859z",
    clipRule: "evenodd",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.44 75.307l8.498.047-.004.859-8.5-.047z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 9,
    height: 35,
    x: 39,
    y: 75,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M39.864 75.309l7.65.042-.477 9.451-.283-.002-.165 4.297-.493-.003-1.743 20.615-1.7-.009-1.52-20.634-.493-.002-.118-4.298-.284-.002-.373-9.455z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.864 75.309l7.65.042-.477 9.451-6.799-.038-.373-9.455z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.498 83.906l6.29.035-.199 5.156-5.95-.033-.141-5.158z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.07 88.207l5.099.028-1.817 21.474-1.7-.009-1.583-21.493z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.653 109.7l1.7.01-.005.858-1.7-.009z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.92 88.211l.987 21.49-.254-.001-1.503-20.634-.51-.002-.147-4.298-.255-.002-.378-8.596 1.277-.422.782 12.465zM45.319 88.23l-1.222 21.478.255.001 1.727-20.615.51.003.193-4.296.255.001.472-8.591-1.273-.437-.917 12.456z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M47.934 76.213l-8.355-.046-.149.858 8.47.047.034-.859zm-7.566 8.552l7.52.042-.031.859-7.624-.042.135-.859zm.782 4.301l4.93.028-.022.859-4.998-.028.09-.859z",
    clipRule: "evenodd",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.869 73.307l9.272.052-.005.938-9.272-.052z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    width: 9,
    height: 38,
    x: 25,
    y: 73,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.332 73.31l8.345.046-.52 10.31-.308-.002-.18 4.687-.538-.003-1.902 22.49-1.855-.011-1.658-22.51-.538-.002-.129-4.688-.309-.002-.407-10.315z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.332 73.31l8.345.046-.52 10.31-7.417-.041-.407-10.315z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.023 82.689l6.862.038-.216 5.624-6.49-.036-.156-5.626z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.647 87.38l5.563.03-1.982 23.428-1.854-.011-1.727-23.447z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.374 110.827l1.854.01-.005.937-1.854-.01z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.574 87.385l1.078 23.444-.278-.002-1.64-22.51-.556-.002-.16-4.689-.278-.001-.413-9.378 1.394-.46.853 13.598zM31.283 87.406l-1.333 23.43.279.002 1.883-22.49.556.003.211-4.687.279.002.514-9.372-1.388-.477-1.001 13.589z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M34.136 74.296l-9.115-.05-.162.936 9.24.052.037-.938zm-8.255 9.33l8.204.045-.034.938-8.316-.047.146-.936zm.854 4.692l5.377.03-.023.937-5.452-.03.098-.937z",
    clipRule: "evenodd",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.397 73.307l9.272.052-.006.938-9.271-.052z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    width: 10,
    height: 38,
    x: 43,
    y: 73,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43.86 73.31l8.345.046-.52 10.31-.309-.002-.18 4.687-.537-.003-1.903 22.49-1.854-.011-1.658-22.51-.538-.002-.129-4.688-.309-.002-.408-10.315z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.86 73.31l8.345.046-.52 10.31-7.417-.041-.408-10.315z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.551 82.689l6.861.038-.215 5.624-6.49-.036-.156-5.626z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.175 87.38l5.563.03-1.982 23.428-1.854-.011-1.727-23.447z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.902 110.827l1.854.01-.005.937-1.854-.01z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.102 87.385l1.078 23.444-.278-.002-1.64-22.51-.556-.002-.16-4.689-.278-.001-.413-9.378 1.393-.46.854 13.598zM49.81 87.406l-1.332 23.43.278.002 1.884-22.49.556.003.211-4.687.278.002.515-9.372-1.388-.477-1.001 13.589z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M52.663 74.296l-9.114-.05-.163.936 9.24.052.037-.938zm-8.254 9.33l8.204.045-.034.938-8.316-.047.146-.936zm.853 4.692l5.378.03-.024.937-5.451-.03.097-.937z",
    clipRule: "evenodd",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.935 73.307l9.272.052-.005.938-9.272-.052z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    width: 9,
    height: 38,
    x: 61,
    y: 73,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M61.399 73.31l8.345.046-.52 10.31-.309-.002-.18 4.687-.538-.003-1.902 22.49-1.854-.011-1.659-22.51-.537-.002-.13-4.688-.308-.002-.408-10.315z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.399 73.31l8.345.046-.52 10.31-7.417-.041-.408-10.315z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.09 82.689l6.861.038-.216 5.624-6.49-.036-.155-5.626z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.713 87.38l5.563.03-1.981 23.428-1.854-.011-1.728-23.447z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.44 110.827l1.854.01-.005.937-1.854-.01z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.64 87.385l1.079 23.444-.279-.002-1.64-22.51-.555-.002-.16-4.689-.279-.001-.412-9.378 1.393-.46.853 13.598zM67.35 87.406l-1.333 23.43.278.002 1.884-22.49.556.003.21-4.687.279.002.514-9.372-1.388-.477-1 13.589z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M70.202 74.296l-9.115-.05-.162.936 9.24.052.037-.938zm-8.254 9.33l8.203.045-.033.938-8.317-.047.147-.936zm.853 4.692l5.378.03-.024.937-5.452-.03.098-.937z",
    clipRule: "evenodd",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.867 70.307l9.89.055-.006 1.016-9.89-.055z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    width: 10,
    height: 41,
    x: 12,
    y: 70,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.36 70.31l8.902.05-.555 11.168-.33-.002-.192 5.078-.574-.004-2.031 24.365-1.978-.011-1.767-24.386-.573-.003-.138-5.079-.33-.002-.433-11.174z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.36 70.31l8.902.05-.555 11.168-7.912-.044-.434-11.174z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.097 80.47l7.319.041-.231 6.093-6.923-.039-.165-6.094z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.762 85.552l5.934.033-2.116 25.38-1.978-.011-1.84-25.402z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.602 110.954l1.978.011-.005 1.016-1.978-.011z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.75 85.558l1.149 25.397-.297-.001-1.747-24.385-.593-.004-.17-5.079-.297-.002-.44-10.158 1.487-.5.909 14.732zM18.707 85.58l-1.424 25.383.297.002L19.592 86.6l.593.004.225-5.077.297.001.55-10.153-1.481-.516-1.07 14.72z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M21.75 71.378l-9.722-.054-.173 1.014 9.857.055.039-1.015zm-8.804 10.107l8.75.049-.036 1.015-8.87-.049.156-1.015zm.91 5.084l5.735.031-.025 1.016-5.815-.032.104-1.016z",
    clipRule: "evenodd",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.658 70.307l9.89.055-.006 1.016-9.89-.055z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "q",
    width: 10,
    height: 41,
    x: 31,
    y: 70,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M31.152 70.31l8.901.05-.555 11.168-.33-.002-.192 5.078-.574-.004-2.03 24.365-1.979-.011-1.767-24.386-.573-.003-.137-5.079-.33-.002-.434-11.174z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.152 70.31l8.901.05-.555 11.168-7.912-.044-.434-11.174z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.888 80.47l7.319.041-.23 6.093-6.924-.039-.165-6.094z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.553 85.552l5.934.033-2.116 25.38-1.978-.011-1.84-25.402z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.393 110.954l1.978.011-.005 1.016-1.978-.011z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.542 85.558l1.148 25.397-.297-.001-1.747-24.385-.593-.004-.17-5.079-.297-.002-.44-10.158 1.487-.5.909 14.732zM37.498 85.58l-1.423 25.383.296.002L38.383 86.6l.593.004.226-5.077.296.001.55-10.153-1.481-.516-1.069 14.72z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M40.542 71.378l-9.722-.054-.173 1.014 9.856.055.04-1.015zm-8.805 10.107l8.75.049-.036 1.015-8.87-.049.156-1.015zm.91 5.084l5.736.031-.026 1.016-5.815-.032.104-1.016z",
    clipRule: "evenodd",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.46 70.307l9.89.055-.006 1.016-9.89-.055z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    width: 10,
    height: 41,
    x: 48,
    y: 70,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M48.954 70.31l8.901.05-.555 11.168-.33-.002-.192 5.078-.573-.004-2.032 24.364-1.978-.011-1.766-24.385-.574-.003-.137-5.079-.33-.002-.434-11.174z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.954 70.31l8.901.05-.555 11.168-7.912-.044-.434-11.174z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.69 80.47l7.32.04-.232 6.093-6.923-.038-.164-6.095z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.355 85.552l5.934.033-2.116 25.379-1.978-.011-1.84-25.4z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.196 110.953l1.978.011-.006 1.016-1.978-.011z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.344 85.558l1.148 25.397-.296-.002-1.747-24.385-.594-.003-.17-5.08h-.297l-.44-10.16 1.487-.5.91 14.733zM55.3 85.58l-1.423 25.383.297.001L56.185 86.6l.593.004.226-5.077.296.001.55-10.153-1.48-.516-1.07 14.72z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M58.344 71.378l-9.722-.054-.173 1.014 9.856.055.04-1.015zM49.54 81.485l8.75.049-.035 1.015-8.871-.05.156-1.014zm.91 5.083l5.736.032-.026 1.016-5.815-.032.105-1.016z",
    clipRule: "evenodd",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.251 70.307l9.89.055-.005 1.016-9.89-.055z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "u",
    width: 10,
    height: 41,
    x: 67,
    y: 70,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M67.746 70.31l8.9.05-.555 11.168-.33-.002-.192 5.078-.573-.004-2.031 24.364-1.978-.011-1.767-24.385-.573-.003-.138-5.079-.33-.002-.433-11.174z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.746 70.31l8.9.05-.555 11.168-7.911-.044-.434-11.174z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.482 80.47l7.319.04-.231 6.093-6.923-.038-.165-6.095z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M69.147 85.552l5.933.033-2.115 25.379-1.978-.011-1.84-25.4z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.987 110.953l1.978.011-.006 1.016-1.978-.011z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.135 85.558l1.148 25.397-.296-.002-1.747-24.385-.593-.003-.17-5.08h-.297l-.44-10.16 1.486-.5.91 14.733zM74.092 85.58l-1.424 25.383.297.001L74.976 86.6l.594.004.225-5.077.297.001.55-10.153-1.481-.516-1.07 14.72z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M77.136 71.378l-9.723-.054-.173 1.014 9.857.055.039-1.015zM68.33 81.485l8.75.049-.035 1.015-8.871-.05.156-1.014zm.91 5.083l5.736.032-.025 1.016-5.816-.032.105-1.016z",
    clipRule: "evenodd",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F79689",
    fillRule: "evenodd",
    d: "M8.923 86.619a2 2 0 0 0-2 2v7.064H2.99a2 2 0 0 0-2 2v2.03h5.934v.014a2 2 0 0 0 2 2h71.165a2 2 0 0 0 2-2v-.015h6.923v-2.029a2 2 0 0 0-2-2h-4.923V88.62a2 2 0 0 0-2-2H8.923z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE7062",
    fillRule: "evenodd",
    d: "M79.12 95.683H6.924V88.62a2 2 0 0 1 2-2h.967v5.036h69.23v-5.036h.968a2 2 0 0 1 2 2v7.064H79.12zm-78.131 2a2 2 0 0 1 2-2h.967v4.03H.989v-2.03zm86.022-2h-.967v4.03h2.967v-2.03a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0",
    d: "M85.82 102.227c-.12.345-.275.824-.457 1.444-.422 1.442-.982 3.646-1.542 6.716-1.105 6.065-2.206 15.506-2.233 29.113h-11.27l-2.382-.97-.09-.037H21.165l-.09.037-2.383.97H8.412c-.024-13.357-1.003-22.792-1.984-28.914-.497-3.098-.994-5.348-1.37-6.826a37.736 37.736 0 0 0-.419-1.533H85.82z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E5ECF0",
    strokeWidth: 2,
    d: "M3.956 100.719s3.956 11.079 3.956 38.274h10.88l2.472-1.007h46.483l2.473 1.007h11.868c0-27.698 3.956-38.274 3.956-38.274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5ECF0",
    d: "M.989 99.712h88.022a2.015 2.015 0 0 1-2.014 2.015H3.003A2.015 2.015 0 0 1 .99 99.712z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E5ECF0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M68.242 137.986v-17.025c0-5.134-6.655-13.191-23.515-13.191-16.859 0-23.958 8.057-23.958 13.191v17.025"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.78,
    height: 6.043,
    x: 34.615,
    y: 104.748,
    fill: "#F5F7F9",
    opacity: 0.6,
    rx: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h90v140H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h8.499v55H0z",
    transform: "rotate(.314 -13564.164 3806.168) skewX(.007)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h8.499v55H0z",
    transform: "rotate(.314 -13546.94 10176.507) skewX(.007)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h8.499v55H0z",
    transform: "rotate(.314 -13555.134 7145.852) skewX(.007)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.272v60H0z",
    transform: "rotate(.314 -13201.87 4518.46) skewX(.007)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.272v60H0z",
    transform: "rotate(.314 -13192.84 7858.18) skewX(.007)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.272v60H0z",
    transform: "rotate(.314 -13184.317 11019.613) skewX(.007)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.89v65H0z",
    transform: "rotate(.314 -12667.426 2173.257) skewX(.007)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.89v65H0z",
    transform: "rotate(.314 -12658.268 5560.456) skewX(.007)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.89v65H0z",
    transform: "rotate(.314 -12649.555 8769.401) skewX(.007)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.89v65H0z",
    transform: "rotate(.314 -12640.42 12156.622) skewX(.007)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2TipBoxOpen);
export default __webpack_public_path__ + "static/media/p2-tip-box-open.8cdb9f816e6d4dbcf3d4186d42a4e920.svg";
export { ForwardRef as ReactComponent };